// annual-plan-actual-mapping plugin — server-side only.
// No client-side extension points registered for this plugin.
// initAnnualPlanActualMapping is intentionally NOT added to plugin-registry.ts.
export const initAnnualPlanActualMapping = (): void => {
    // No client-side registrations needed for this sub-plugin.
    // All functionality is Excel generation on the server side.
};
